export const TOTAL_STEPS_COUNT = 4;

export const STEP_DATA = [
  { step: 1, label: 'Get started' },
  { step: 2, label: 'Install location' },
  { step: 3, label: 'Instructions' },
  { step: 4, label: 'Business details' },
];
